import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Container, Box, Divider, CardContent, Typography } from '@material-ui/core';
import AMC from '../../assets/logoamc.png';

import LogoExtended from '../../assets/extendedLogo.svg';

import { optionStyles } from './styles';
import Colors from '../../components/Colors';


function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const ForgotPassword: React.FC = () => {
  const query = useQuery();
  const classes = optionStyles();
  return (
    <Container maxWidth="xl" className={classes.rootContainer}>
      <Box className={classes.rootCard}>
        <CardContent style={{ width: '80%' }}>
          <img src={LogoExtended} alt="Logo VIDA" width="200" className={classes.logo} />
          <Divider className={classes.divider} orientation="horizontal" />
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
            }}
          >
            <Typography variant="h6" style={{ color: '#1D1D1B', marginBottom: '5%' }}>
              E-mail enviado com sucesso!
            </Typography>
          </div>

          <Typography style={{ marginBottom: 30 }}>
            O email de verificação foi enviado para{' '}
            <Typography style={{ color: Colors.main }}>{query.get('email')}. </Typography>{' '}
            Verifique a caixa de entrada do seu e-mail, e realize as instruções
            necessárias!
          </Typography>
          <Link className={classes.link} to="/login">
            Ir a tela de login
          </Link>
        </CardContent>
        <img src={AMC} alt="Logo VIDA" width="200" className={classes.logoamc} />
      </Box>
    </Container>
  );
};

export default ForgotPassword;
